import { runtimeEnv } from 'config/runtimeEnv';
import requestInstance from './Request';
import { API_ENDPOINT } from './Api';

let env = runtimeEnv('B2B_API_BASE_URL');
// Reupload compliance service
export const postReuploadCompliance = async (formData) => {
  try {
    const response = await requestInstance.post(
      // `${env}${API_ENDPOINT.ReUploadCompliance.api}`,
      `${env}/admin-api/v3/compliance-resubmit`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error('Reupload Compliance error:', error);
    throw error;
  }
};
